import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/privacy',
    name: 'Privacy',
    meta: {
      title: '隐私政策'
    },
    component: () => import('../views/Privacy.vue')
  },
  {
    path: '/agreement',
    name: 'Agreement',
    meta: {
      title: '用户协议'
    },
    component: () => import('../views/Agreement.vue')
  },
  {
    path: '/privacy_pad',
    name: 'PadPrivacy',
    meta: {
      title: '隐私政策'
    },
    component: () => import('../views/PadPrivacy.vue')
  },
  {
    path: '/agreement_pad',
    name: 'PadAgreement',
    meta: {
      title: '用户协议'
    },
    component: () => import('../views/PadAgreement.vue')
  },
  {
    path: '/permission',
    name: 'Permission',
    meta: {
      title: '权限说明'
    },
    component: () => import('../views/Permission.vue')
  },
  {
    path: '/permission_pad',
    name: 'PadPermission',
    meta: {
      title: '权限说明'
    },
    component: () => import('../views/PadPermission.vue')
  },
  {
    path: '/fall',
    name: 'Fall',
    component: () => import(/* webpackChunkName: "Fall" */ '../views/Fall.vue'),
    meta: {
      title: '置业顾问',
      needLoading: false
    }
  },
  // 智分客
  {
    path: '/privacy-zfk',
    name: 'PrivacyZFK',
    meta: {
      title: '隐私政策'
    },
    component: () => import('../views/PrivacyZFK.vue')
  },
  {
    path: '/agreement-zfk',
    name: 'AgreementZFK',
    meta: {
      title: '用户协议'
    },
    component: () => import('../views/AgreementZFK.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
